module.exports = __webpack_public_path__ + "static/media/logo.3d272182.png";